import { ErrorMessage } from "@hookform/error-message";
import { Input, Modal } from "@mantine/core";
import {
  Dropzone,
  type FileWithPath,
  IMAGE_MIME_TYPE,
} from "@mantine/dropzone";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import {
  type Control,
  type FieldErrors,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

import { FileInput, Group, Text } from "@/components/ui/elements";

import classes from "./_css/index.module.css";

type Props<FORM_TYPE extends FieldValues> = {
  opened: boolean;
  open: () => void;
  close: () => void;
  control: Control<FORM_TYPE>;
  name: FieldPath<FORM_TYPE>;
  errors?: FieldErrors;
  accept?: string[];
};

export function ModalDropzone<FORM_TYPE extends FieldValues>(
  props: Props<FORM_TYPE>,
) {
  const {
    opened,
    open,
    close,
    control,
    name,
    errors,
    accept = IMAGE_MIME_TYPE,
  } = props;
  const { field } = useController({
    name,
    control,
  });
  const [files, setFiles] = useState<FileWithPath[]>([]);
  const hasImage = field.value && files.length;

  useEffect(() => {
    if (!field.value) {
      setFiles([]);
    }
  }, [field.value]);

  const Previews = () => {
    if (field.value && !files.length) {
      return (
        <Group className={classes.image} justify="center">
          <Image src={field.value} alt="image" fill />
        </Group>
      );
    }
    return files.map((file, index) => {
      const imageUrl = URL.createObjectURL(file);
      return (
        <Group className={classes.image} justify="center" key={index}>
          <Image src={imageUrl} alt="image" fill />
        </Group>
      );
    });
  };
  const handleDrop = (file: FileWithPath[]) => {
    setFiles(file);
    field.onChange(file);
  };
  return (
    <div>
      <FileInput
        name={field.name}
        value={field.value}
        onChange={field.onChange}
        ref={field.ref}
        disabled
        style={{ display: "none" }}
      />
      <Modal opened={opened} onClose={close} centered>
        <Dropzone mih={300} accept={accept} onDrop={(file) => handleDrop(file)}>
          <Group justify="center">
            {!hasImage && <Text>画像を選択してください</Text>}
            <Previews />
          </Group>
        </Dropzone>
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => <Input.Error>{message}</Input.Error>}
        />
      </Modal>
    </div>
  );
}
